export default __webpack_public_path__ + "static/media/plumber1.a442190e.png";